import { Injectable } from '@angular/core';
import { reportType, reportName } from './Util';

@Injectable()
export class ControlStatusService {
  private _currentState: State = State.visaoGeral;
  public mostrarMapas: boolean = false;
  public mostrarLegendas: boolean = false;
  public carregando: boolean = false;
  public dateChange: boolean = false;
  public numeroRoteiroBusca: number;
  public numeroRoteiroBuscaDetalhe: boolean;
  public carregouMapa: boolean = false;
  public popupConfig: boolean = false;
  public mostrarApenasPendentes: boolean = false;
  public msgErroBusca: string = '';

  //CONTROLES RELATÓRIOS
  public empresaSelecionada: string = ''
  public tipoRelatorio: number
  public carregandoRelatorios: boolean = false;
  public carregandoRelatoriosJasper: boolean = false;
  public dataInicio: any = '';
  public dataFim: any = '';
  public avisoRelatorio: string = '';
  public erroRelatorio: boolean = false;
  public controleModeloReport: string = 'pdf'
  public reportName:reportName
  public reportName2:reportName
  public reportFolder: any = '';
  public nomeMotorista = '';


  set currentState(stt: State) {
    this._currentState = stt;
  }

  get currentState(): State {
    return this._currentState;
  }

  controlarLoading(show) {
    this.carregandoRelatorios = show;
  }

  limpaEstadoRelatorios() {
    this.dataInicio = '';
    this.dataFim = '';
    this.avisoRelatorio = '';
    this.erroRelatorio = false;
    this.controleModeloReport = ''
    this.tipoRelatorio = null;
    this.nomeMotorista = '';
  }

}


export enum State {
  'visualizadorLinhasPontos' = 0,
  'visualizadorDeRoteiros' = 1,
  'visaoGeral' = 2
}


